/**
 * Principal Repository
 */

import { apiClient } from '../../client'

import type { PaginatedResponse } from '../role.repository'

export interface Principal {
    id: number
    tenant_id: number

    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date

    ref_code?: string
}

export interface CreatePrincipalRequest {
    tenant_id: number

    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdatePrincipalRequest {
    tenant_id?: number

    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class PrincipalRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Principal>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)

            if (filters.principal_id) params.append('principal_id', filters.principal_id)
        }

        return apiClient.get<PaginatedResponse<Principal>>(`/principals?${params.toString()}`)
    }

    async getById(id: number): Promise<Principal> {
        return apiClient.get<Principal>(`/principals/${id}`)
    }

    async create(data: CreatePrincipalRequest): Promise<Principal> {
        return apiClient.post<Principal>('/principals', data)
    }

    async update(id: number, data: UpdatePrincipalRequest): Promise<Principal> {
        return apiClient.put<Principal>(`/principals/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/principals/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters?.principal_id) params.append('principal_id', filters.principal_id.toString())

        const baseUrl = `/principals/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const principalRepository = new PrincipalRepository()

